import script from "./PhotovoltaicOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhotovoltaicOverview.vue?vue&type=script&setup=true&lang=ts"

import "./PhotovoltaicOverview.vue?vue&type=style&index=0&id=4b54366d&scoped=true&lang=scss"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b54366d"]])

export default __exports__